import { GET_SCR_SUMMARY_REPORT } from "../../../../Types"

const initialState = {}

const SCRSummaryReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SCR_SUMMARY_REPORT:
            return {
                ...state,
                [action.payload.key]: action.payload.data
            }
        default:
            return state
    }
}

export default SCRSummaryReportReducer